import { render, staticRenderFns } from "./VIDEOFILE.vue?vue&type=template&id=a09f658a&scoped=true&lang=pug"
import script from "./VIDEOFILE.vue?vue&type=script&lang=js"
export * from "./VIDEOFILE.vue?vue&type=script&lang=js"
import style0 from "./VIDEOFILE.vue?vue&type=style&index=0&id=a09f658a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09f658a",
  null
  
)

export default component.exports